/* eslint-disable eqeqeq */

import { useSelector, useDispatch } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";

import { fAlertToast, fcovertToNumber } from "../../Utility/Utilitys";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import "./WmsDashboard.css";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Summary_Columns_Def } from "./WmsDashboardAction";
import GCDataGrid from "./processComponent/GCDataGrid";
import GCModal from "./processComponent/GCModal";
import { CmpTypographyField } from "../../Component/Common/ToolBox/ToolBox";
import PurchaseOrder from "./processComponent/PurchaseOrder";
export default function WmsDashboardDetail() {
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:450px)");


  return (
    <div className="container-fluid my-3">
      <div  >
        <Grid container spacing={0}>
          <Grid item xs={12} md={8} className="m-auto">
            <PurchaseOrder />
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
